import { useState, useEffect } from 'react';

/**
 * useIsMobile
 * Returns true when viewport width is below the given breakpoint.
 * Re-renders only when the threshold is crossed (not on every resize).
 *
 * @param {number} breakpoint - px width (default 768)
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < breakpoint
  );

  useEffect(() => {
    const mq      = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
